import type { PanelField } from '../../components/panel-fields.js';
import type { CatalogProcess } from '../../lib/catalog-api.js';

// #28 + #44: Die Feldliste des Prozesses. Vier dieser Felder (name_en, sap_scope_item_id,
// in_scope, notes) hatten bis hierhin ueberhaupt kein Bedienelement — in_scope war deshalb nur
// per Import setzbar, wodurch #44 gar nicht pruefbar gewesen waere.
export type ProcessDraft = {
  name_de: string;
  name_en: string;
  sap_scope_item_id: string | null;
  in_scope: boolean;
  notes: string | null;
  // #112: EIN Teilprojekt statt einer Liste. Die Maske las ohnehin immer nur den ersten Eintrag —
  // jetzt steht die Regel im Typ. null = „Ohne Teilprojekt".
  node_id: string | null;
};

export const emptyProcessDraft: ProcessDraft = {
  name_de: '',
  name_en: '',
  sap_scope_item_id: null,
  in_scope: true,
  notes: null,
  node_id: null,
};

export function toProcessDraft(p: CatalogProcess, nodeId: string | null): ProcessDraft {
  return {
    name_de: p.name_de,
    name_en: p.name_en,
    sap_scope_item_id: p.sap_scope_item_id,
    in_scope: p.in_scope,
    notes: p.notes,
    node_id: nodeId,
  };
}

export function processFields(
  t: (k: string) => string,
  streams: { node_id: string; name: string }[],
): PanelField<ProcessDraft>[] {
  return [
    {
      key: 'name_de',
      labelKey: t('catalog.fields.nameDe'),
      kind: 'text',
      get: (d) => d.name_de,
      set: (d, v) => ({ ...d, name_de: v }),
    },
    {
      key: 'name_en',
      labelKey: t('catalog.fields.nameEn'),
      kind: 'text',
      get: (d) => d.name_en,
      set: (d, v) => ({ ...d, name_en: v }),
    },
    {
      key: 'sap_scope_item_id',
      labelKey: t('catalog.fields.sapScopeItemId'),
      kind: 'text',
      get: (d) => d.sap_scope_item_id ?? '',
      set: (d, v) => ({ ...d, sap_scope_item_id: v || null }),
    },
    {
      // #44: heisst bewusst NICHT „In Scope" — das waere mit dem Testplan-Scope verwechselbar.
      key: 'in_scope',
      labelKey: t('catalog.fields.conversionScope'),
      kind: 'checkbox',
      hintKey: t('catalog.fields.conversionScopeHint'),
      get: (d) => d.in_scope,
      set: (d, v) => ({ ...d, in_scope: v }),
    },
    {
      key: 'notes',
      labelKey: t('catalog.fields.notes'),
      kind: 'textarea',
      get: (d) => d.notes ?? '',
      set: (d, v) => ({ ...d, notes: v || null }),
    },
    {
      // #112: genau EIN Teilprojekt. Knoten ANLEGEN bleibt #46 (Admin „Projektstruktur").
      // Die Auswahl bietet nur Teilprojekte an — Streams tragen Ketten, keine Prozesse; der
      // Server weist ein Stream-Ziel mit 400 ab.
      key: 'node_id',
      labelKey: t('catalog.tree.teilprojekt'),
      kind: 'select',
      get: (d) => d.node_id,
      set: (d, v) => ({ ...d, node_id: v || null }),
      options: streams.map((s) => ({ value: s.node_id, label: s.name })),
      allowEmpty: true,
      emptyLabel: t('catalog.tree.withoutTeilprojekt'),
    },
  ];
}
